import { Dialog, DialogActions, DialogContent } from '@mui/material';

import { styled } from '../../Utils/style';

export default styled(Dialog)`
  ${(props) => {
    const { theme } = props;

    return `
			[role="dialog"] {
				outline: none;
			}

			.MuiDivider-root {
				margin-top: 1.8rem;
			}

			.MuiDialogTitle-root {
				color: ${theme?.materialDialog?.title.color};
				display: flex;
				flex-direction: column;
				padding: 0.8rem 3.8rem;

				.MuiDivider-root {
					margin-top: 1.8rem;
				}
			}

			.dialog-close-icon {
				padding: 0;
				align-self: end;
			}

			.MuiDialog-paperFullScreen .MuiDialogActions-root {
				padding: 3.9rem 0 1.8rem 0;
				flex-direction: column-reverse;
				align-self: center;
			}

			.dialog-content-title {
				margin-bottom: ${theme.spacing(4.12)};
			}

			&.force-scrollbar .MuiDialogContent-root {
				scrollbar-color: #9e9e9e transparent;
				scrollbar-width: thin;
			}

			${theme.breakpoints.up('sm')} {
				.MuiDialog-paperFullScreen {
					max-width: 55rem;
					height: 65.3rem;
					border-radius: 0.8rem;
				}
			}
		`;
  }}
`;

export const MaterialDialogContent = styled(DialogContent)``;
export const MaterialDialogActions = styled(DialogActions)``;
